<template>
    <div class="top_tab" :style="style">
        <div class="btn">
            <img src="@/assets/imgs/icon19.png" alt="" @click="showSide = true">
        </div>
        <div class="icons">
            <span class="btn">
                <img src="@/assets/imgs/icon2.png" @click="router.push('/workbench/assets-lib/home')" alt="">
            </span>
            <span class="btn">
                <img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" @click="showActionSheet = true" />
                <img class="avatar" src="@/assets/imgs/icon1.png" v-else @click="router.push('/login')" alt />
            </span>
        </div>
    </div>
    <div class="wrapper" @click="showSide = false" v-show="showSide">
        <aside @click.stop="() => null">
            <img src="@/assets/imgs/logo.png" alt="" @click="router.push('/')" />
            <ul class="tabs">
                <li :class="{ active: route.path == '/' }"><router-link to="/">首页</router-link></li>
                <li :class="{ active: route.path == '/art' }"><router-link to="/art">艺术鉴赏</router-link></li>
                <li :class="{ active: route.path == '/artist' }"><router-link to="/artist">艺术家</router-link></li>
                <li :class="{ active: route.path == '/collection' }"><router-link to="/collection">数字藏品</router-link>
                </li>
                <li :class="{ active: route.path == '/culture' }"><router-link to="/culture">九色文化</router-link></li>
            </ul>
        </aside>
    </div>
    <van-action-sheet v-model:show="showActionSheet" :actions="actions" @select="onSelect" />
</template>
<script setup>
import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import cookie from 'cookie.js'

const props = defineProps({
    style: {
        type: Number,
        default: 0
    }
})
const router = useRouter(), route = useRoute()
const active = ref(0)
const showSide = ref(false)
const store = useStore()
const userInfo = computed(() => {
    return store.state.login.userInfo
})

const showActionSheet = ref(false)
const actions = [
    { name: '账户设置' },
    { name: '退出登录' }
];
const onSelect = (item) => {
    showActionSheet.value = false;
    if (item.name == '退出登录') {
        logout()
    }
    if (item.name == '账户设置') {
        router.push('/workbench/personal/account')
    }
};

const logout = () => {
    cookie.remove('accessToken', {path: '/'})
    cookie.remove('tenantId', {path: '/'})
    if(route.path.startsWith('/workbench')){
        router.replace('/')
    }
    setTimeout(() => {
        location.reload()
    }, 0)
}
</script>
<style scoped lang="scss">
.top_tab {
    padding: 0 10rem;
    display: flex;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #fff;
}

.icons {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60rem;
}

.btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60rem;
    width: 35rem;

    img {
        width: 24rem;
        height: 24rem;

    }
    .avatar {
        border-radius: 50%;
    }
}

.wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}

aside {
    width: 150rem;
    height: 100vh;
    background-color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    transition: all 1s ease-in-out;

    img {
        width: 85rem;
        margin: 0 33rem;
    }

    ul {
        li {
            height: 48rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14rem;

            a {
                color: #000;
            }
        }

        .active {
            background-color: #F7F7F9;
        }
    }
}
</style>